export const CustomSeparator = ({...props}: any) => (
  <div className='d-flex my-6'>
    <div className='fs-4 fw-bolder' style={{marginRight: '2em'}}>
      {props.title}
    </div>
    <div className='separator border-solid flex-fill align-self-center'></div>
  </div>
)
